import React, { useState, useEffect } from 'react'
import { connect } from 'formik'
import { FormattedMessage } from 'react-intl'
import GroupList from '../GroupList'
import Checkbox from '@iui-kit/components/Checkbox'
import { Formik } from '@src/types/BriefSearch/formikProps'

interface Inputs {
  label: string
  value: string
}

interface Props {
  name: string
  inputs: Inputs[]
}

interface HOCProps {
  formik: Formik
}

const CheckboxGroup: React.FC<Props & HOCProps> = props => {
  const {
    name,
    inputs,
    formik: { values, errors, touched, handleBlur, setFieldValue }
  } = props

  const [checkedInputs, setChecked] = useState<Array<string>>([])

  useEffect(() => {
    const defaultState: Array<string> = Array.isArray(values[name])
      ? values[name]
      : values[name].split(',')

    setChecked(defaultState)
  }, [])

  const handleCheckboxChange = (value: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked: boolean = e.target.checked
    const state: Array<string> = checkedInputs

    if (isChecked) {
      state.push(value)
    } else {
      const idx = state.indexOf(value)
      state.splice(idx, 1)
    }

    setChecked(state)
    setFieldValue(name, state.join())
  }

  return (
    <GroupList name={name}>
      {inputs.map((item, idx) => (
        <Checkbox
          key={idx}
          name={name}
          value={item.value}
          isValid={!errors[name] || !touched[name]}
          checked={checkedInputs.includes(item.value)}
          onChange={handleCheckboxChange(item.value)}
          onBlur={handleBlur}
        >
          <FormattedMessage id={item.label} />
        </Checkbox>
      ))}
    </GroupList>
  )
}

export default connect<Props>(CheckboxGroup)
